import { LoginFormAbstract } from './login-form/login-form.model'
import { ExternalProviderConfig } from './external-provider/external-provider-config.model'

export enum CredentialType {
  mobilePhoneOnly,
  emailAddressOnly,
  emailAddressAndMobilePhone,
}

export interface LoginConfig {
  singleSignOn: {
    clientName: string
  }
  credentialType: CredentialType
  paths: {
    _root: string
    clientLogin: string
    ssoLogin: string
  }
  form: {
    fields: LoginFormAbstract
  }
  helpInfoMessageVisible: boolean
  externalProvider: ExternalProviderConfig
}
